let tenant = null;

function getConfig(name, defaultValue=null) {
    // If inside a docker container, use window.ENV
    if( window.ENV !== undefined ) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
      
    
    if (getConfig('REACT_APP_BACKEND_URL')) {
        return getConfig('REACT_APP_BACKEND_URL');
    }else{

        if (window.localStorage.getItem("tenant"))
            tenant = window.localStorage.getItem("tenant");

        return  `https://api-${tenant}.send4whats.com`;
    }
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}